import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectfieldcustomComponent } from './selectfieldcustom.component';



@NgModule({
  declarations: [SelectfieldcustomComponent],
  exports:[SelectfieldcustomComponent],
  imports: [
    CommonModule
  ]
})
export class SelectfieldcustomModule { }
